import { render, staticRenderFns } from "./NewLangsModal.vue?vue&type=template&id=4e4efb21&"
import script from "./NewLangsModal.vue?vue&type=script&lang=js&"
export * from "./NewLangsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports